msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: ordered.length
#: src/components/ExecutionUsageChip.tsx
msgid "{0, plural, one {# execution total} other {# executions total}}"
msgstr "{0, plural, one {# execution total} other {# executions total}}"

#. placeholder {0}: day.messages
#: src/components/PersonalOverview.tsx
msgid "{0, plural, one {# message} other {# messages}}"
msgstr "{0, plural, one {# message} other {# messages}}"

#. placeholder {0}: day.tasks_created
#: src/components/PersonalOverview.tsx
msgid "{0, plural, one {# task created} other {# tasks created}}"
msgstr "{0, plural, one {# task created} other {# tasks created}}"

#. placeholder {0}: person.task_count
#: src/components/PersonalOverview.tsx
msgid "{0, plural, one {# task together} other {# tasks together}}"
msgstr "{0, plural, one {# task together} other {# tasks together}}"

#. placeholder {0}: members.length
#: src/components/InsightsPanel.tsx
msgid "{0, plural, one {active collaborator} other {active collaborators}}"
msgstr "{0, plural, one {active collaborator} other {active collaborators}}"

#. placeholder {0}: active.length
#: src/components/InsightsPanel.tsx
msgid "{0, plural, one {work item in motion} other {work items in motion}}"
msgstr "{0, plural, one {work item in motion} other {work items in motion}}"

#. placeholder {0}: formatDate(i18n, new Date(`${day.date}T00:00:00Z`), { dateStyle: 'medium', timeZone: 'UTC' })
#: src/components/PersonalOverview.tsx
msgid "{0} (UTC)"
msgstr "{0} (UTC)"

#. placeholder {0}: task.title
#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "{0} has no task thread"
msgstr "{0} has no task thread"

#. placeholder {0}: formatNumber(i18n, done)
#. placeholder {1}: formatNumber(i18n, plan.length)
#: src/components/ActivityPanel.tsx
msgid "{0} of {1} done"
msgstr "{0} of {1} done"

#. placeholder {0}: formatNumber(i18n, left)
#: src/components/ActivityPanel.tsx
msgid "{0} to go"
msgstr "{0} to go"

#. placeholder {0}: formatTokens(i18n, total)
#: src/components/ExecutionUsageChip.tsx
msgid "{0} tok"
msgstr "{0} tok"

#. placeholder {0}: formatTokens(i18n, total)
#: src/components/InsightsPanel.tsx
msgid "{0} tokens"
msgstr "{0} tokens"

#. placeholder {0}: formatNumber(i18n, minutes)
#: src/components/ActivityPanel.tsx
msgid "{0}m"
msgstr "{0}m"

#: src/components/ActivityBar.tsx
msgid "{active, plural, one {# active} other {# active}} · {total, plural, one {# background run} other {# background runs}}"
msgstr "{active, plural, one {# active} other {# active}} · {total, plural, one {# background run} other {# background runs}}"

#: src/lib/channel-activity.ts
msgid "{count, plural, one {# agent waiting for you} other {# agents waiting for you}}"
msgstr "{count, plural, one {# agent waiting for you} other {# agents waiting for you}}"

#: src/lib/channel-activity.ts
msgid "{count, plural, one {# agent working} other {# agents working}}"
msgstr "{count, plural, one {# agent working} other {# agents working}}"

#: src/lib/channel-activity.ts
msgid "{count, plural, one {# person typing} other {# people typing}}"
msgstr "{count, plural, one {# person typing} other {# people typing}}"

#: src/components/InsightsPanel.tsx
msgid "{done, plural, one {completed task contribution} other {completed task contributions}}"
msgstr "{done, plural, one {completed task contribution} other {completed task contributions}}"

#: src/lib/channel-activity.ts
msgid "{first} and {second} are typing"
msgstr "{first} and {second} are typing"

#: src/lib/channel-activity.ts
msgid "{first} and {second} are waiting for you"
msgstr "{first} and {second} are waiting for you"

#: src/lib/channel-activity.ts
msgid "{first} and {second} are working"
msgstr "{first} and {second} are working"

#: src/lib/channel-activity.ts
msgid "{first} is typing"
msgstr "{first} is typing"

#: src/lib/channel-activity.ts
msgid "{first} is waiting for you"
msgstr "{first} is waiting for you"

#: src/lib/channel-activity.ts
msgid "{first} is working"
msgstr "{first} is working"

#: src/components/StopTurnButton.tsx
msgid "{label}, {displayName}"
msgstr "{label}, {displayName}"

#. placeholder {0}: formatTokens(i18n, value)
#: src/components/ExecutionUsageChip.tsx
msgid "{name}: {0}"
msgstr "{name}: {0}"

#: src/components/ExecutionUsageChip.tsx
msgid "{scopeTitle}. {label}."
msgstr "{scopeTitle}. {label}."

#: src/components/ExecutionUsageChip.tsx
msgid "{scopeTitle}. View token usage."
msgstr "{scopeTitle}. View token usage."

#: src/components/ActivityBar.tsx
msgid "{total, plural, one {# background run} other {# background runs}}"
msgstr "{total, plural, one {# background run} other {# background runs}}"

#: src/components/PersonalOverview.tsx
msgid "{total, plural, one {# message in the last year} other {# messages in the last year}}"
msgstr "{total, plural, one {# message in the last year} other {# messages in the last year}}"

#: src/components/InsightsPanel.tsx
msgid "{totalMessages, plural, one {# message} other {# messages}} · {totalTasks, plural, one {# task contribution} other {# task contributions}}"
msgstr "{totalMessages, plural, one {# message} other {# messages}} · {totalTasks, plural, one {# task contribution} other {# task contributions}}"

#: src/components/ExecutionUsageChip.tsx
msgid "Abandoned"
msgstr "Abandoned"

#: src/components/ActivityPanel.tsx
msgid "Active now"
msgstr "Active now"

#: src/components/TasksPanel.tsx
msgid "Additional check instructions (e.g. check deploy health, summarize for customer)"
msgstr "Additional check instructions (e.g. check deploy health, summarize for customer)"

#: src/components/TasksPanel.tsx
msgid "Advanced: Custom Prompt (optional)"
msgstr "Advanced: Custom Prompt (optional)"

#: src/components/PersonalOverview.tsx
msgid "Agent"
msgstr "Agent"

#: src/components/TaskPropertiesEditor.tsx
msgid "Agent Session"
msgstr "Agent Session"

#: src/components/PersonalOverview.tsx
msgid "Agents do work in your spaces."
msgstr "Agents do work in your spaces."

#: src/components/PersonalTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "All"
msgstr "All"

#: src/components/ExecutionUsageChip.tsx
msgid "All executions"
msgstr "All executions"

#: src/components/ServerTasksPage.tsx
msgid "All tasks"
msgstr "All tasks"

#: src/components/StopTurnButton.tsx
msgid "Already asked to stop"
msgstr "Already asked to stop"

#: src/components/ActivityPanel.tsx
msgid "Already stopping"
msgstr "Already stopping"

#. placeholder {0}: task.seq
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Are you sure you want to delete task #{0}?"
msgstr "Are you sure you want to delete task #{0}?"

#: src/components/PersonalOverview.tsx
msgid "Assign your first Task"
msgstr "Assign your first Task"

#: src/components/PersonalTasksPage.tsx
msgid "Assigned to you"
msgstr "Assigned to you"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Assignee"
msgstr "Assignee"

#: src/components/InsightsPanel.tsx
msgid "Authorized Project message and Task creation activity over the last year (UTC)"
msgstr "Authorized Project message and Task creation activity over the last year (UTC)"

#: src/components/ActivityPanel.tsx
msgid "Background completed"
msgstr "Background completed"

#: src/components/ActivityPanel.tsx
msgid "Background failed"
msgstr "Background failed"

#: src/components/ActivityPanel.tsx
msgid "background job"
msgstr "background job"

#: src/components/ActivityPanel.tsx
msgid "Background work"
msgstr "Background work"

#: src/components/TasksPanel.tsx
msgid "Board view"
msgstr "Board view"

#: src/components/ExecutionUsageChip.tsx
msgid "Cache"
msgstr "Cache"

#. placeholder {0}: formatTokens(i18n, execution.cache_read_tokens + execution.cache_write_tokens)
#: src/components/ExecutionUsageChip.tsx
msgid "Cache: {0}"
msgstr "Cache: {0}"

#: src/components/PersonalOverview.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/components/ActivityPanel.tsx
#: src/lib/taskStatus.tsx
msgid "Cancelled"
msgstr "Cancelled"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksTableView.tsx
msgid "Channel"
msgstr "Channel"

#: src/components/ExecutionUsageChip.tsx
msgid "Channel rollup"
msgstr "Channel rollup"

#: src/components/ServerTasksPage.tsx
msgid "Channel unavailable"
msgstr "Channel unavailable"

#: src/components/ActivityPanel.tsx
msgid "Close"
msgstr "Close"

#: src/components/InsightsPanel.tsx
msgid "Collaboration"
msgstr "Collaboration"

#: src/components/TasksBoardView.tsx
msgid "Collapse {label} column"
msgstr "Collapse {label} column"

#: src/components/PersonalOverview.tsx
msgid "Color represents messages from you and your Agents in related Task threads; Task count is shown separately. Project Insights remains the whole space’s activity."
msgstr "Color represents messages from you and your Agents in related Task threads; Task count is shown separately. Project Insights remains the whole space’s activity."

#: src/components/InsightsPanel.tsx
msgid "Color represents messages. Tooltip counts show messages and canonical Tasks created on each UTC day across Channels you are authorized to view."
msgstr "Color represents messages. Tooltip counts show messages and canonical Tasks created on each UTC day across Channels you are authorized to view."

#: src/components/ActivityPanel.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Completed"
msgstr "Completed"

#: src/components/PersonalOverview.tsx
msgid "Connect a computer when your Agents need one."
msgstr "Connect a computer when your Agents need one."

#: src/components/PersonalOverview.tsx
msgid "Connected recently"
msgstr "Connected recently"

#: src/components/PersonalOverview.tsx
msgid "Continue"
msgstr "Continue"

#: src/components/PersonalOverview.tsx
msgid "Continue: {taskTitle}"
msgstr "Continue: {taskTitle}"

#: src/components/TaskPropertiesEditor.tsx
msgid "Copied"
msgstr "Copied"

#. placeholder {0}: propertyLabel(definition, i18n)
#: src/components/TaskPropertiesEditor.tsx
msgid "Copied {0}"
msgstr "Copied {0}"

#. placeholder {0}: propertyLabel(definition, i18n)
#: src/components/TaskPropertiesEditor.tsx
msgid "Copy {0}"
msgstr "Copy {0}"

#: src/components/TaskPropertiesEditor.tsx
msgid "Copy failed"
msgstr "Copy failed"

#: src/components/TasksPanel.tsx
msgid "Could not create the task. Your inputs are still here; retry when ready."
msgstr "Could not create the task. Your inputs are still here; retry when ready."

#: src/components/ServerTasksPage.tsx
msgid "Could not create the task. Your inputs are still here."
msgstr "Could not create the task. Your inputs are still here."

#: src/components/ServerTasksPage.tsx
msgid "Could not load channel members. Close and reopen this form to retry."
msgstr "Could not load channel members. Close and reopen this form to retry."

#: src/components/ServerTasksPage.tsx
msgid "Could not load Project tasks."
msgstr "Could not load Project tasks."

#: src/components/TasksPanel.tsx
msgid "Could not load repository mappings from the selected computer. Check Remote Helper, then retry."
msgstr "Could not load repository mappings from the selected computer. Check Remote Helper, then retry."

#: src/components/PersonalOverview.tsx
msgid "Could not load your overview."
msgstr "Could not load your overview."

#: src/components/TasksPanel.tsx
msgid "Could not save the task. Your inputs are still here; retry when ready."
msgstr "Could not save the task. Your inputs are still here; retry when ready."

#: src/components/ActivityPanel.tsx
#: src/components/StopTurnButton.tsx
msgid "Could not stop"
msgstr "Could not stop"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "Create"
msgstr "Create"

#: src/components/PersonalOverview.tsx
msgid "Create Agent"
msgstr "Create Agent"

#: src/components/PersonalOverview.tsx
msgid "Create an Agent to start collaborating."
msgstr "Create an Agent to start collaborating."

#: src/components/PersonalOverview.tsx
msgid "Create your first Agent"
msgstr "Create your first Agent"

#: src/components/PersonalTasksPage.tsx
msgid "Created by you"
msgstr "Created by you"

#: src/components/TasksPanel.tsx
msgid "Creating..."
msgstr "Creating..."

#: src/components/ServerTasksPage.tsx
msgid "Creating…"
msgstr "Creating…"

#: src/components/TasksPanel.tsx
msgid "Creator"
msgstr "Creator"

#: src/components/InsightsPanel.tsx
msgid "Daily token consumption"
msgstr "Daily token consumption"

#: src/components/TasksPanel.tsx
msgid "Default execution"
msgstr "Default execution"

#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: task.title
#: src/components/TaskRowActions.tsx
msgid "Delete {0}"
msgstr "Delete {0}"

#: src/components/TasksTableView.tsx
msgid "Delete task"
msgstr "Delete task"

#: src/components/TasksPanel.tsx
msgid "Delete Task"
msgstr "Delete Task"

#. placeholder {0}: task.seq
#: src/components/TaskRowActions.tsx
msgid "Delete task #{0}?"
msgstr "Delete task #{0}?"

#: src/components/TasksTableView.tsx
msgid "Delete task?"
msgstr "Delete task?"

#: src/components/ServerTasksPage.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
msgid "Description"
msgstr "Description"

#: src/components/TaskHeartbeatControl.tsx
msgid "Disable heartbeat"
msgstr "Disable heartbeat"

#: src/components/ActivityPanel.tsx
#: src/lib/taskStatus.tsx
msgid "Done"
msgstr "Done"

#: src/components/TasksPanel.tsx
msgid "e.g. Check deploy health and summarize the current status"
msgstr "e.g. Check deploy health and summarize the current status"

#. placeholder {0}: task.title
#: src/components/TaskRowActions.tsx
msgid "Edit {0}"
msgstr "Edit {0}"

#: src/components/TaskRowActions.tsx
#: src/components/TasksBoardView.tsx
#: src/components/TasksTableView.tsx
msgid "Edit task"
msgstr "Edit task"

#: src/components/TasksPanel.tsx
msgid "Edit Task"
msgstr "Edit Task"

#: src/components/TaskHeartbeatControl.tsx
msgid "Enable heartbeat"
msgstr "Enable heartbeat"

#: src/lib/taskHeartbeat.ts
msgid "Every 1 hour"
msgstr "Every 1 hour"

#: src/lib/taskHeartbeat.ts
msgid "Every 10 minutes"
msgstr "Every 10 minutes"

#: src/lib/taskHeartbeat.ts
msgid "Every 15 minutes"
msgstr "Every 15 minutes"

#: src/lib/taskHeartbeat.ts
msgid "Every 2 hours"
msgstr "Every 2 hours"

#: src/lib/taskHeartbeat.ts
msgid "Every 30 minutes"
msgstr "Every 30 minutes"

#: src/lib/taskHeartbeat.ts
msgid "Every 5 minutes"
msgstr "Every 5 minutes"

#. placeholder {0}: formatNumber(i18n, index + 1)
#: src/components/ExecutionUsageChip.tsx
msgid "Execution {0}"
msgstr "Execution {0}"

#: src/components/ActivityPanel.tsx
msgid "Execution detail"
msgstr "Execution detail"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Local Directory"
msgstr "Execution Local Directory"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Remote Node"
msgstr "Execution Remote Node"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Repository"
msgstr "Execution Repository"

#: src/components/ExecutionUsageChip.tsx
msgid "Execution token trend, oldest to newest"
msgstr "Execution token trend, oldest to newest"

#: src/components/TasksPanel.tsx
msgid "Execution Workspace"
msgstr "Execution Workspace"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Workspace Source"
msgstr "Execution Workspace Source"

#: src/components/ExecutionUsageChip.tsx
msgid "Executions"
msgstr "Executions"

#: src/components/TasksBoardView.tsx
msgid "Expand {label} column"
msgstr "Expand {label} column"

#: src/components/ActivityPanel.tsx
#: src/components/ExecutionUsageChip.tsx
msgid "Failed"
msgstr "Failed"

#: src/components/TaskRowActions.tsx
#: src/components/TasksTableView.tsx
msgid "Failed to delete task"
msgstr "Failed to delete task"

#: src/components/InsightsPanel.tsx
msgid "Failed to load Project insights."
msgstr "Failed to load Project insights."

#: src/components/TaskHeartbeatControl.tsx
msgid "Failed to update heartbeat"
msgstr "Failed to update heartbeat"

#: src/components/TaskRowActions.tsx
msgid "Failed to update task"
msgstr "Failed to update task"

#: src/components/ExecutionUsageChip.tsx
msgid "Finished"
msgstr "Finished"

#: src/components/PersonalOverview.tsx
msgid "Fri"
msgstr "Fri"

#: src/components/TasksPanel.tsx
msgid "GitHub Repository"
msgstr "GitHub Repository"

#: src/components/TasksPanel.tsx
msgid "GitHub Repository on selected computer"
msgstr "GitHub Repository on selected computer"

#: src/components/PersonalOverview.tsx
msgid "Give one of your Agents work in a channel."
msgstr "Give one of your Agents work in a channel."

#: src/components/TasksPanel.tsx
msgid "Heartbeat"
msgstr "Heartbeat"

#: src/components/ActivityPanel.tsx
msgid "Hide"
msgstr "Hide"

#: src/components/ExecutionUsageChip.tsx
msgid "Hide execution details"
msgstr "Hide execution details"

#: src/components/PersonalOverview.tsx
msgid "Hover a day for details"
msgstr "Hover a day for details"

#: src/components/TasksTableView.tsx
msgid "ID"
msgstr "ID"

#: src/components/PersonalOverview.tsx
msgid "Idle"
msgstr "Idle"

#: src/components/ExecutionUsageChip.tsx
#: src/components/PersonalTasksPage.tsx
msgid "In progress"
msgstr "In progress"

#: src/lib/taskStatus.tsx
msgid "In Progress"
msgstr "In Progress"

#: src/components/PersonalTasksPage.tsx
msgid "In review"
msgstr "In review"

#: src/lib/taskStatus.tsx
msgid "In Review"
msgstr "In Review"

#: src/components/ExecutionUsageChip.tsx
msgid "Input"
msgstr "Input"

#. placeholder {0}: formatTokens(i18n, execution.input_tokens)
#. placeholder {1}: formatTokens(i18n, execution.output_tokens)
#: src/components/ExecutionUsageChip.tsx
msgid "Input: {0} · Output: {1}"
msgstr "Input: {0} · Output: {1}"

#: src/components/TaskPropertiesEditor.tsx
msgid "Issue"
msgstr "Issue"

#: src/components/PersonalOverview.tsx
msgid "Join a Project"
msgstr "Join a Project"

#: src/components/PersonalOverview.tsx
msgid "Less"
msgstr "Less"

#: src/components/ExecutionUsageChip.tsx
msgid "Lifecycle complete"
msgstr "Lifecycle complete"

#: src/components/ExecutionUsageChip.tsx
msgid "Lifecycle partial"
msgstr "Lifecycle partial"

#: src/components/ExecutionUsageChip.tsx
msgid "Loading executions…"
msgstr "Loading executions…"

#: src/components/InsightsPanel.tsx
msgid "Loading Project pulse…"
msgstr "Loading Project pulse…"

#: src/components/ServerTasksPage.tsx
msgid "Loading Project tasks…"
msgstr "Loading Project tasks…"

#: src/components/TasksPanel.tsx
msgid "Loading repository capability and mappings from the selected computer..."
msgstr "Loading repository capability and mappings from the selected computer..."

#: src/components/TasksPanel.tsx
msgid "Loading repository mappings..."
msgstr "Loading repository mappings..."

#: src/components/PersonalOverview.tsx
msgid "Loading your overview…"
msgstr "Loading your overview…"

#: src/components/PersonalTasksPage.tsx
msgid "Loading your tasks…"
msgstr "Loading your tasks…"

#: src/components/PersonalOverview.tsx
msgid "Member"
msgstr "Member"

#: src/components/InsightsPanel.tsx
msgid "Messages"
msgstr "Messages"

#: src/components/PersonalOverview.tsx
msgid "Mon"
msgstr "Mon"

#: src/components/PersonalOverview.tsx
msgid "More"
msgstr "More"

#: src/components/PersonalTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "My Tasks"
msgstr "My Tasks"

#: src/components/PersonalOverview.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Needs attention"
msgstr "Needs attention"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "New Task"
msgstr "New Task"

#: src/components/ActivityPanel.tsx
msgid "New task activity is unavailable because earlier requests occupy the local display capacity."
msgstr "New task activity is unavailable because earlier requests occupy the local display capacity."

#: src/components/PersonalOverview.tsx
msgid "Next up"
msgstr "Next up"

#: src/components/ExecutionUsageChip.tsx
msgid "No executions to chart."
msgstr "No executions to chart."

#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "No matching tasks."
msgstr "No matching tasks."

#: src/components/TasksPanel.tsx
msgid "No repository mappings found. Go to Computers, clone the repository on that computer, then bind its directory."
msgstr "No repository mappings found. Go to Computers, clone the repository on that computer, then bind its directory."

#: src/components/PersonalTasksPage.tsx
msgid "No tasks here."
msgstr "No tasks here."

#: src/components/InsightsPanel.tsx
msgid "No visible contributors yet."
msgstr "No visible contributors yet."

#: src/components/InsightsPanel.tsx
msgid "No visible task activity yet."
msgstr "No visible task activity yet."

#: src/components/PersonalOverview.tsx
msgid "Not connected yet"
msgstr "Not connected yet"

#: src/components/StopTurnButton.tsx
msgid "Nothing to stop"
msgstr "Nothing to stop"

#: src/components/PersonalOverview.tsx
msgid "Offline"
msgstr "Offline"

#: src/components/PersonalOverview.tsx
msgid "Online"
msgstr "Online"

#: src/components/TaskPropertiesEditor.tsx
msgid "Open"
msgstr "Open"

#: src/lib/taskStatus.tsx
msgctxt "Task status"
msgid "Open"
msgstr "Open"

#. placeholder {0}: task.title
#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "Open {0}"
msgstr "Open {0}"

#. placeholder {0}: source.guild_name
#. placeholder {1}: source.channel_name
#: src/components/TasksTableView.tsx
msgid "Open {0} #{1}"
msgstr "Open {0} #{1}"

#: src/components/PersonalOverview.tsx
msgid "Open an invite link from a Project owner, or create your own Project."
msgstr "Open an invite link from a Project owner, or create your own Project."

#: src/components/TasksPanel.tsx
msgid "Open the task's channel to load available assignees. Other task fields can still be edited."
msgstr "Open the task's channel to load available assignees. Other task fields can still be edited."

#: src/components/TasksBoardView.tsx
#: src/components/TasksTableView.tsx
msgid "Open thread"
msgstr "Open thread"

#: src/components/TasksPanel.tsx
msgid "Optional description"
msgstr "Optional description"

#: src/components/ExecutionUsageChip.tsx
msgid "Output"
msgstr "Output"

#: src/components/PersonalOverview.tsx
msgid "Overview"
msgstr "Overview"

#: src/components/InsightsPanel.tsx
msgid "Partial coverage — telemetry was reported, but no complete token trend is available."
msgstr "Partial coverage — telemetry was reported, but no complete token trend is available."

#: src/components/TasksTableView.tsx
msgid "Participants"
msgstr "Participants"

#: src/components/PersonalOverview.tsx
msgid "Paste a Borgee invite link from this Project."
msgstr "Paste a Borgee invite link from this Project."

#: src/components/PersonalOverview.tsx
msgid "Paste an invite link from a Project owner. You will review and accept the invitation before joining."
msgstr "Paste an invite link from a Project owner. You will review and accept the invitation before joining."

#: src/components/InsightsPanel.tsx
msgid "People contributing to visible work"
msgstr "People contributing to visible work"

#: src/components/TasksPanel.tsx
msgid "Periodic check-in prompt"
msgstr "Periodic check-in prompt"

#: src/components/TasksPanel.tsx
msgid "Periodic check-in prompt (optional)"
msgstr "Periodic check-in prompt (optional)"

#: src/components/PersonalOverview.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Personal"
msgstr "Personal"

#: src/components/PersonalOverview.tsx
msgid "Personal overview"
msgstr "Personal overview"

#: src/components/PersonalOverview.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Personal task"
msgstr "Personal task"

#: src/components/InsightsPanel.tsx
msgid "Project activity rhythm"
msgstr "Project activity rhythm"

#: src/components/PersonalOverview.tsx
msgid "Project invite link"
msgstr "Project invite link"

#: src/components/InsightsPanel.tsx
msgid "Project pulse"
msgstr "Project pulse"

#: src/components/TaskPropertiesEditor.tsx
msgid "Properties"
msgstr "Properties"

#: src/components/TaskPropertiesEditor.tsx
msgid "Pull Request"
msgstr "Pull Request"

#: src/components/ActivityPanel.tsx
msgid "Queued"
msgstr "Queued"

#: src/components/ActivityPanel.tsx
msgid "Read-only · This earlier request is no longer active."
msgstr "Read-only · This earlier request is no longer active."

#: src/components/ActivityPanel.tsx
msgid "Read-only · This session is unavailable."
msgstr "Read-only · This session is unavailable."

#: src/components/InsightsPanel.tsx
msgid "Recently updated across visible channels"
msgstr "Recently updated across visible channels"

#. placeholder {0}: propertyLabel(definition, i18n)
#: src/components/TaskPropertiesEditor.tsx
msgid "Remove {0}"
msgstr "Remove {0}"

#: src/components/InsightsPanel.tsx
msgid "Reported telemetry from visible conversations."
msgstr "Reported telemetry from visible conversations."

#: src/components/ExecutionUsageChip.tsx
msgid "Reports"
msgstr "Reports"

#: src/components/TasksPanel.tsx
msgid "Repository and selected computer are fixed after mapping."
msgstr "Repository and selected computer are fixed after mapping."

#: src/components/TasksPanel.tsx
msgid "Repository execution is unavailable while the selected computer is offline."
msgstr "Repository execution is unavailable while the selected computer is offline."

#: src/components/TasksPanel.tsx
msgid "Repository mapping can only be added before the task starts."
msgstr "Repository mapping can only be added before the task starts."

#: src/components/TasksPanel.tsx
msgid "Repository mapping is missing. Clone the repository on the selected computer, bind that directory in Computers, then retry."
msgstr "Repository mapping is missing. Clone the repository on the selected computer, bind that directory in Computers, then retry."

#: src/components/TasksPanel.tsx
msgid "Repository mappings are available only to the owner of the selected computer."
msgstr "Repository mappings are available only to the owner of the selected computer."

#: src/components/TasksPanel.tsx
msgid "Repository mappings are managed in Computers. Borgee never clones or pulls repositories."
msgstr "Repository mappings are managed in Computers. Borgee never clones or pulls repositories."

#: src/components/TasksPanel.tsx
msgid "Repository-mapped task stays on its selected computer. You may choose another assignee on that computer or clear the assignee."
msgstr "Repository-mapped task stays on its selected computer. You may choose another assignee on that computer or clear the assignee."

#: src/components/PersonalOverview.tsx
msgid "Resume work in this task thread."
msgstr "Resume work in this task thread."

#: src/components/ServerTasksPage.tsx
msgid "Retry"
msgstr "Retry"

#: src/components/ActivityPanel.tsx
msgid "Running"
msgstr "Running"

#: src/components/ActivityPanel.tsx
msgid "Running in background"
msgstr "Running in background"

#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
msgid "Save"
msgstr "Save"

#: src/components/TaskPropertiesEditor.tsx
msgid "Save failed"
msgstr "Save failed"

#: src/components/TasksPanel.tsx
msgid "Saving..."
msgstr "Saving..."

#: src/components/TaskRowActions.tsx
msgid "Saving…"
msgstr "Saving…"

#: src/components/ServerTasksPage.tsx
msgid "Search Project tasks"
msgstr "Search Project tasks"

#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "Search results"
msgstr "Search results"

#: src/components/PersonalTasksPage.tsx
msgid "Search tasks"
msgstr "Search tasks"

#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "Search tasks…"
msgstr "Search tasks…"

#: src/components/ServerTasksPage.tsx
msgid "Select a channel"
msgstr "Select a channel"

#: src/components/TasksPanel.tsx
msgid "Select a repository"
msgstr "Select a repository"

#: src/components/TasksPanel.tsx
msgid "Select assignee"
msgstr "Select assignee"

#: src/components/TasksPanel.tsx
msgid "Sent to the assignee each time this task's heartbeat runs. It replaces the default “Heartbeat: status update requested” check-in message and does not change the task description or instructions."
msgstr "Sent to the assignee each time this task's heartbeat runs. It replaces the default “Heartbeat: status update requested” check-in message and does not change the task description or instructions."

#: src/components/ExecutionUsageChip.tsx
msgid "Started"
msgstr "Started"

#: src/components/ActivityPanel.tsx
msgid "Started {startedLabel} · {elapsedLabel}"
msgstr "Started {startedLabel} · {elapsedLabel}"

#. placeholder {0}: run.parentActivityLabel
#: src/components/ActivityPanel.tsx
msgid "Started by {0}"
msgstr "Started by {0}"

#: src/components/ActivityPanel.tsx
msgid "Starting in background"
msgstr "Starting in background"

#: src/components/ServerTasksPage.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Status"
msgstr "Status"

#: src/components/ExecutionUsageChip.tsx
msgid "Status: {status}"
msgstr "Status: {status}"

#: src/components/ActivityPanel.tsx
#: src/components/StopTurnButton.tsx
msgid "Stop"
msgstr "Stop"

#: src/components/ActivityPanel.tsx
msgid "Stop requested"
msgstr "Stop requested"

#: src/components/StopTurnButton.tsx
msgid "Stopped"
msgstr "Stopped"

#: src/components/ActivityPanel.tsx
msgid "Stopping"
msgstr "Stopping"

#: src/components/ActivityPanel.tsx
#: src/components/StopTurnButton.tsx
msgid "Stopping…"
msgstr "Stopping…"

#: src/components/ActivityPanel.tsx
msgid "sub-agent"
msgstr "sub-agent"

#: src/components/ExecutionUsageChip.tsx
msgid "Succeeded"
msgstr "Succeeded"

#: src/components/TasksPanel.tsx
msgid "Table view"
msgstr "Table view"

#: src/components/TaskRowActions.tsx
#: src/components/TasksTableView.tsx
msgid "Task deleted"
msgstr "Task deleted"

#. placeholder {0}: task.id
#. placeholder {1}: i18n._(STATUS_COLUMNS.find(column => column.key === task.status)!.label)
#: src/components/TaskStatusPill.tsx
msgid "Task ID: {0} · Status: {1}"
msgstr "Task ID: {0} · Status: {1}"

#: src/components/TasksPanel.tsx
msgid "Task title"
msgstr "Task title"

#: src/components/InsightsPanel.tsx
#: src/components/ServerTasksPage.tsx
msgid "Tasks"
msgstr "Tasks"

#: src/components/PersonalOverview.tsx
msgid "Tasks you are assigned to or participating in will appear here."
msgstr "Tasks you are assigned to or participating in will appear here."

#: src/components/TasksPanel.tsx
msgid "The selected computer is offline. Start Remote Helper, then retry."
msgstr "The selected computer is offline. Start Remote Helper, then retry."

#: src/components/TasksPanel.tsx
msgid "This assignee is not linked to a repository-capable managed computer."
msgstr "This assignee is not linked to a repository-capable managed computer."

#: src/components/TasksPanel.tsx
msgid "This assignee must join the channel before receiving a new assignment."
msgstr "This assignee must join the channel before receiving a new assignment."

#: src/components/ActivityPanel.tsx
msgid "This background run is no longer active"
msgstr "This background run is no longer active"

#: src/components/ActivityPanel.tsx
msgid "This provider does not support targeted background-run cancellation"
msgstr "This provider does not support targeted background-run cancellation"

#: src/components/ExecutionUsageChip.tsx
msgid "This task thread"
msgstr "This task thread"

#: src/components/ExecutionUsageChip.tsx
msgid "This thread"
msgstr "This thread"

#: src/components/ServerTasksPage.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Title"
msgstr "Title"

#. placeholder {0}: formatTokens(i18n, total)
#: src/components/ExecutionUsageChip.tsx
msgid "Token breakdown: {0} total"
msgstr "Token breakdown: {0} total"

#: src/components/InsightsPanel.tsx
msgid "Token consumption over time"
msgstr "Token consumption over time"

#: src/components/ExecutionUsageChip.tsx
#: src/components/InsightsPanel.tsx
msgid "Token usage"
msgstr "Token usage"

#: src/components/ExecutionUsageChip.tsx
msgid "Token usage for this channel and threads you can access"
msgstr "Token usage for this channel and threads you can access"

#: src/components/ExecutionUsageChip.tsx
msgid "Token usage for this task thread"
msgstr "Token usage for this task thread"

#: src/components/ExecutionUsageChip.tsx
msgid "Token usage for this thread"
msgstr "Token usage for this thread"

#: src/components/ExecutionUsageChip.tsx
msgid "Top models"
msgstr "Top models"

#: src/components/ExecutionUsageChip.tsx
msgid "Total"
msgstr "Total"

#. placeholder {0}: formatTokens(i18n, tokens)
#: src/components/ExecutionUsageChip.tsx
msgid "Total: {0} tokens"
msgstr "Total: {0} tokens"

#: src/components/ActivityPanel.tsx
msgid "Typing"
msgstr "Typing"

#: src/components/TaskStatusPill.tsx
msgid "Unassigned"
msgstr "Unassigned"

#: src/components/InsightsPanel.tsx
msgid "Unavailable — no telemetry was reported from visible conversations."
msgstr "Unavailable — no telemetry was reported from visible conversations."

#: src/components/ActivityPanel.tsx
msgid "Unknown"
msgstr "Unknown"

#: src/components/TasksPanel.tsx
msgid "Update Remote Helper on the selected computer to enable repository mappings."
msgstr "Update Remote Helper on the selected computer to enable repository mappings."

#: src/components/TasksTableView.tsx
msgid "Updated"
msgstr "Updated"

#: src/components/ExecutionUsageChip.tsx
#: src/components/TasksTableView.tsx
msgid "Usage"
msgstr "Usage"

#: src/components/PersonalOverview.tsx
msgid "View all"
msgstr "View all"

#: src/components/ExecutionUsageChip.tsx
msgid "View lifecycle details"
msgstr "View lifecycle details"

#: src/components/ActivityPanel.tsx
msgid "Waiting"
msgstr "Waiting"

#: src/components/ActivityPanel.tsx
msgid "Waiting for you"
msgstr "Waiting for you"

#: src/components/ActivityPanel.tsx
msgid "Waiting in background"
msgstr "Waiting in background"

#: src/components/PersonalOverview.tsx
msgid "Wed"
msgstr "Wed"

#: src/components/InsightsPanel.tsx
msgid "Work in motion"
msgstr "Work in motion"

#: src/components/ActivityPanel.tsx
#: src/components/PersonalOverview.tsx
msgid "Working"
msgstr "Working"

#: src/components/PersonalOverview.tsx
msgid "Working with"
msgstr "Working with"

#. placeholder {0}: person.task_title
#: src/components/PersonalOverview.tsx
msgid "Working with you on “{0}”"
msgstr "Working with you on “{0}”"

#: src/components/TaskPropertiesEditor.tsx
msgid "Workspace Mode"
msgstr "Workspace Mode"

#: src/components/PersonalTasksPage.tsx
msgid "You participate"
msgstr "You participate"

#: src/components/PersonalTasksPage.tsx
msgid "Your agent"
msgstr "Your agent"

#: src/components/PersonalOverview.tsx
msgid "Your agents"
msgstr "Your agents"

#: src/components/PersonalOverview.tsx
msgid "Your computers"
msgstr "Your computers"

#: src/components/PersonalOverview.tsx
msgid "Your message activity in task threads over the last year"
msgstr "Your message activity in task threads over the last year"

#: src/components/PersonalOverview.tsx
msgid "Your work"
msgstr "Your work"

#: src/components/PersonalOverview.tsx
msgid "Your work rhythm"
msgstr "Your work rhythm"
